module.exports = __webpack_public_path__ + "img/moviles2.26fb9ebc.png";